export const ESTADO_TEMPORAL = 1
export const ESTADO_ACTIVA = 2
export const ESTADO_VENCIDA = 3
export const ESTADOS = [
  { idTiendaOficialEstado: ESTADO_ACTIVA, nombre: 'Activa' },
  { idTiendaOficialEstado: ESTADO_VENCIDA, nombre: 'Vencida' }
]
